// reach_ui/src/components/VastGPT/ChatInput.js
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { IconButton } from '@material-ui/core'
import { Send } from '@material-ui/icons'
import TextareaAutosize from 'react-textarea-autosize'
import { sendMessageToOpenAi } from './redux'
import { read } from '../../actions/data'
import { DATA_API_URL } from '../../utils/AllURLs'

const ChatInput = ({
  isDisabled,
  startPolling,
  read,
  setDisabled,
  selectedChatId,
  sendMessageToOpenAi,
  loadingResponse,
}) => {
  const [input, setInput] = useState('')

  const handleInputChange = e => {
    setInput(e.target.value)
  }

  const handleSend = async () => {
    if (input.trim()) {
      setDisabled(true)

      if (selectedChatId) {
        try {
          const readPayload = await read(
            selectedChatId,
            'openaichat',
            null,
            null,
            'object',
            null,
            null,
            `${DATA_API_URL}/openaichat/${selectedChatId}`,
          )

          if (readPayload.status === 'REQUEST') {
            startPolling()
          } else {
            await sendMessageToOpenAi({
              chatId: selectedChatId,
              content: input.trim(),
            })
            setInput('')
            setDisabled(false)
            startPolling()
          }
        } catch (error) {
          console.error('Error checking chat status:', error)
          setDisabled(false)
        }
      } else {
        await sendMessageToOpenAi({ content: input.trim(), firstMessage: true })
        setDisabled(false)
      }
    }
  }

  return (
    <div className="AiChatInputContainer">
      <TextareaAutosize
        placeholder="Enter a message..."
        maxRows={4}
        value={input}
        onChange={handleInputChange}
        // disabled={isDisabled}
      />
      <IconButton
        color="secondary"
        disabled={!input.trim() || isDisabled || loadingResponse}
        onClick={handleSend}
      >
        <Send />
      </IconButton>
    </div>
  )
}

export default connect(null, dispatch =>
  bindActionCreators({ sendMessageToOpenAi, read }, dispatch),
)(ChatInput)
